/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} St_Cl_PhaseInputs */

const en_st_cl_phase = /** @type {(inputs: St_Cl_PhaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Phase ${i?.n}`)
};

const id_st_cl_phase = /** @type {(inputs: St_Cl_PhaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fase ${i?.n}`)
};

/**
* | output |
* | --- |
* | "Phase {n}" |
*
* @param {St_Cl_PhaseInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_cl_phase = /** @type {((inputs: St_Cl_PhaseInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Cl_PhaseInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_cl_phase(inputs)
	return en_st_cl_phase(inputs)
});